(ns hai.contacts.helpers
  (:require
   [hai.ui.icons :as icons]
   [hai.ui.tokens :as t]))

(def query
  "Contact attrs a share picker needs: identity, display, and the emails/uuid
   that map a selected contact onto a share scope."
  [:contact/uuid
   :contact/full-name
   :contact/email])

(def ->label :contact/full-name)

(defn ->label+email [{:contact/keys [full-name email]}]
  [:span [:strong full-name]
   " " (first email)])

(def icon icons/outlined-person)

(def org-icon icons/outlined-groups)

(defn org?
  "True when the contact is an organisation. Resolvers hand clients the flat
   `:contact/organisation?` boolean (pathom can't plan a `{:contact/type
   [:db/ident]}` join — `:db/ident` has no resolver); form state and the
   contacts table still carry `:contact/type`, as a bare enum keyword or a
   pulled `{:db/ident …}` ref."
  [{:contact/keys [organisation? type]}]
  (or (true? organisation?)
      (= (or (:db/ident type) type) :contact.type/organisation)))

(defn type-icon
  "The glyph for a contact — a group for organisations, a person otherwise."
  [contact]
  (if (org? contact) org-icon icon))

(defn ->icon
  [_task]
  icon)

(defn ->tint
  [_]
  t/--contact)
